import { FORNECEDORES, TIPO_IMOVEL, TIPO_IMOVEL_LISTA } from '@/constants'
import { IGenericListItem } from '@/interfaces/IGenericListItem'
import { Constants, FornecedorService } from '@/services'
import { toNumber } from 'lodash'
import Vue, { PropType } from 'vue'
import component from 'vue-class-component'
import { Model, Prop } from 'vue-property-decorator'
import { VCol, VImg, VLayout, VSelect, VTooltip } from 'vuetify/lib'

import './SelectTipoImovel.scss'
import { IFornecedor } from '@/interfaces'

interface SupplierItem {
	id: FORNECEDORES
	icon: string
	propertyTypes: TIPO_IMOVEL[]
}

@component({})
export class SelectTipoImovel extends Vue {
	@Model('input', { type: (Number || null || undefined) as PropType<Number | null | undefined>, required: true }) value!:
		| number
		| null
		| undefined
	@Prop({ type: Number, default: 128 }) itemHeight!: number

	@Prop({ type: String, default: 'card' }) viewType!: string

	lazyValue: TIPO_IMOVEL = TIPO_IMOVEL.RESIDENCIAL
	suppliersValue = new Array<IFornecedor.IFornecedorValores>()

	get internalValue() {
		return this.lazyValue
	}

	get suppliersList() {
		const { state } = this.$store
		const supplierMap = new Map<number, SupplierItem>()

		// Default removed banrisul from suppliers list
		var list = this.suppliersValue.filter((item) => item.fornecedorId != 24)

		// if caixa is not allowed, remove it from the list
		if (!state.user.rules.includes('Isolve.Geral.FornecedorCaixa')) list = list.filter((item) => item.fornecedorId != FORNECEDORES.CAIXA)

		list.forEach((item) => {
			if (!item.desativadoEm && TIPO_IMOVEL_LISTA.find((c) => c.id == item.tipoImovel)) {
				let supplierItem = supplierMap.get(item.fornecedorId)

				if (!supplierItem) {
					supplierItem = {
						id: item.fornecedorId,
						icon: Constants.BANCOS.All.find((bank) => bank.id == toNumber(item.fornecedorId))?.icon || '',
						propertyTypes: []
					}
				}

				if (!supplierItem.propertyTypes.includes(item.tipoImovel)) {
					supplierItem.propertyTypes.push(item.tipoImovel)
				}

				supplierMap.set(item.fornecedorId, supplierItem)
			}
		})

		let supplierList = Array.from(supplierMap.values())

		return supplierList
	}

	set internalValue(value: TIPO_IMOVEL) {
		this.lazyValue = value
		this.$emit('input', value)
	}

	mounted() {
		this.getbanks()

		this.setValue(this.value || TIPO_IMOVEL.RESIDENCIAL)
	}

	render() {
		return <VLayout>{this.renderTipoImovelItems()}</VLayout>
	}

	async getbanks() {
		this.suppliersValue = await FornecedorService.getValores()
	}

	renderTipoImovelItems() {
		if (this.viewType == 'card')
			return TIPO_IMOVEL_LISTA.map((item) => (item.message ? this.renderTipoImovelItemTooltip(item) : this.renderSelectItem(item)))

		if (this.viewType == 'select')
			return <VSelect vModel={this.internalValue} items={TIPO_IMOVEL_LISTA} item-text="description" item-value="id"></VSelect>
	}

	get defaultItemColSize() {
		return 12 / TIPO_IMOVEL_LISTA.length
	}

	renderSelectItem(propertyType: IGenericListItem<TIPO_IMOVEL>, on: any = undefined) {
		return (
			<VCol
				on={on}
				cols="12"
				sm={this.defaultItemColSize}
				data-cy={this.getCyId(propertyType)}
				class={{ 'app-select-tipo-imovel-item': true }}
				onClick={() => this.setValue(propertyType.id)}
			>
				<div class={{ 'app-select-tipo-imovel-input-selected': this.isSelected(propertyType.id), 'app-select-tipo-imovel-input': true }}>
					{propertyType.description}
				</div>
				<div class={' d-inline-flex text-center'}>
					<span class="text-body-2">Bancos Disponíveis: </span>
					{this.suppliersList
						.filter((c) => c.propertyTypes.includes(propertyType.id))
						.map((bank) => (
							<VImg
								style={{
									border: '0 !important',
									borderRadius: 0
								}}
								class="border-0 ml-2 d-inline"
								contain
								src={`/vectors/banks/${bank.icon}`}
								height="24"
								width="24"
							/>
						))}
				</div>
			</VCol>
		)
	}

	renderTipoImovelItemTooltip(item: IGenericListItem<TIPO_IMOVEL>) {
		return (
			<VTooltip
				color="tooltip-background primary--text py-3"
				attach
				bottom
				scopedSlots={{
					activator: ({ on }: { on: any }) => this.renderSelectItem(item, on)
				}}
			>
				<span>{item.message}</span>
			</VTooltip>
		)
	}

	setValue(value: TIPO_IMOVEL) {
		this.internalValue = value
	}

	isSelected(value: TIPO_IMOVEL) {
		return value == this.internalValue
	}

	getCyId(item: IGenericListItem<TIPO_IMOVEL>) {
		return `tipo-imovel-${item.description.toLocaleLowerCase()}`
	}
}

export default SelectTipoImovel
